export default __webpack_public_path__ + "static/media/maintainance1.f3a30573.png";